import { YOUTUBE_VIDEOS } from "../constants"

const videoDataArray = [
  {
    id: 1,
    title: "Movement is Key",
    subtitle: "Video",
    description_1: "Here is what your visit to the clinic may look like.",
    description_2: "",
    link: YOUTUBE_VIDEOS.VIDEO_1
  },
  {
    id: 2,
    title: "Mobility Before Visit",
    subtitle: "Video",
    description_1: "This is an example of a patient's mobility before treatment.",
    description_2: "",
    link: YOUTUBE_VIDEOS.VIDEO_2
  },
  {
    id: 3,
    title: "Mobility After Visit",
    subtitle: "Video",
    description_1: "After a few visits, this was the patients improved mobility.",
    description_2: "",
    link: YOUTUBE_VIDEOS.VIDEO_3
  }
]

export { videoDataArray }